// Could be a json file, but json doesn't allow multiple lines for the description (did not want a really long line in the file).

const projects = [
    {
        id: 'equity',
        title: 'Equity',
        subtitle: 'Web Application',
        image: 'equity.png',
        description: `<p>A web application that allow users to neatly organize their investments by portfolio. Investments and transactions are stored to show their entire investment history.<p>
                      <p>Visit <a href="https://equity-beta.vercel.app" target="_blank" rel="noopener noreferrer">https://equity-beta.vercel.app</a> or click the button below to view the project (beta) in demo mode. 
                      Demo mode has mocked data and some features turned off.</p>`,
        link: "https://equity-beta.vercel.app",
        tags: [ 'C#', 'ASP.NET Core', 'Entity Framework Core', 'SQL (MSSQL)', 'Vue.js', 'JavaScript', 'Vuetify', 'SCSS', 'Font Awesome' ]
    },
    {
        id: 'personal-website',
        title: 'Personal Website',
        subtitle: 'Static Webpage',
        image: 'website.png',
        description: '<p>A personal website leveraging the Vue.js framework and Vuetify UI Library to show experiences, projects, and education.</p>',
        tags: [ 'Vue.js', 'JavaScript', 'Vuetify', 'SCSS', 'Font Awesome' ]
    },
    {
        id: 'peel-locator',
        title: 'Peel Locator',
        subtitle: 'iOS Application',
        image: 'peelLocation.png',
        description: `<p>An iOS application that leverages Apple's MapKit framework to pinpoint and showcase various locations across Region of Peel.</p>
                      <p>Locations include community centers, libraries, and regional offices.</p>`,
        tags: [ 'Swift', 'iOS' ]
    },
    {
        id: 'quadris',
        title: 'Quadris',
        subtitle: 'Linux CLI Game',
        image: 'quadris.png',
        description: `<p>A Linux command-line interface game that mimics the features of Tetris. Quadris was implemented in C++ using X-11 graphics.</p>
                      <p>Blocks are randomly chosen by using a weighted system based on the current level. Quadris also includes a "life saving" feature that players can unlock.</p>`,
        tags: [ 'C++', 'X-11 Graphics', 'Command-line', 'Linux' ]
    },
    {
        id: 'bash-testing-script',
        title: 'Bash Testing Script',
        subtitle: 'Scripting',
        image: 'bash.png',
        description: `<p>A scripting tool developed to automate the testing of C++ programs with the use of input and output files.</p> 
                      <p>With the output file, the script would compare the actual output against the expected output and report any failed tests.</p>`,
        tags: [ 'Bash', 'Command-line', 'Linux' ]
    },
    {
        id: 'powershell-scripts',
        title: 'Powershell Scripts',
        subtitle: 'Scripting',
        image: 'powershell.png',
        description: `<ul>
                        <li>
                            <p><b>Password Notification</b> | The script was developed to help network users know when their password was about to expire. THe script
                            would grab network users on the Active Directory server and compares the last password set date to the current date. The script would
                            email users that their password was soon to be expiring.</p>
                        </li>
                        <li>
                            <p><b>WinSCP Automated File Transfer</b> | The script would automate the transfer process from a Windows Server to a Linux Server. The script would check
                            for files in a specified path and transfer those files to the destination. Once completed, it would notify the setup user with the transfer result.</p>
                        </li>
                        <li>
                            <p><b>User Reporting</b> | A script that would allow network administrators to gather and export information about network accounts. The exported report
                            will be a delimited text file, which can be easily converted and displayed in Excel.</p>
                        </li>
                        <li>
                            <p><b>Account Expiry Notification</b> | A script that checks for about-to-expire network accounts and notifies the employee's manager via email.</p>
                        </li>
                      </ul>`,
        tags: [ 'Powershell', 'Command-line', 'Windows' ]
    },
    {
        id: 'ad-management-tool',
        title: 'Active Directory Tool',
        subtitle: 'Windows Forms',
        image: 'activedirectory.png',
        description: `<p>An Active Directory management tool that assists with user management on a domain controller. This tool allows network administrators to find, enable/disable and change user accounts. 
                      Additionally, administrators can easily reset the user's password. </p>
                      <p>With a click of a button, a report will be generated for the selected user account</p>
                      <p>This domain controller connected tool is based on Windows Powershell with a form like UI.</p>`,
        tags: [ 'Powershell', 'Windows Forms', 'Windows' ]
    }
];

export default projects;